/* eslint-disable */
import { analyticsConstants, urls } from '@/Constants';
import { notificationServices } from '@/Services';
import analyticsServices from '@/Services/analytics.services';
import departmentServices from '@/Services/DepartmentServices/departmentServices';
import moment from 'moment';

const wastageAction = {
	wastageList,
	transitList,
	qualityList,
	aiQualityList,
	grnList,
	notificationList,
	transitLossList,
	faliureRequest,
	loading,
	fetchTransitLossList,
	isSuccess,
	saveTransitLossRecoverdQty,
	setDepartmentsAuditList,
	fetchDepartmentsAuditList,
	setDepartmentsList,
	setUsersList,
};

function wastageList(payload) {
	return {
		type: analyticsConstants.SET_WASTAGE,
		payload,
	};
}

function transitList(payload) {
	return {
		type: analyticsConstants.SET_TRANSIT,
		payload,
	};
}
function qualityList(payload) {
	return {
		type: analyticsConstants.SET_QUALITY,
		payload,
	};
}
function aiQualityList(payload) {
	return {
		type: analyticsConstants.SET_QUALITY_AI,
		payload,
	};
}
function grnList(payload) {
	return {
		type: analyticsConstants.SET_GRN,
		payload,
	};
}
function notificationList(payload) {
	return {
		type: analyticsConstants?.SET_NOTIFICATION,
		payload,
	};
}
function transitLossList(payload) {
	return {
		type: analyticsConstants?.SET_TRANSIT_LOSS,
		payload,
	};
}
function setSingleTransitLoss(payload) {
	return {
		type: analyticsConstants?.SET_SINGLE_TRANSIT_LOSS,
		payload,
	};
}
function faliureRequest(payload) {
	return {
		type: analyticsConstants?.SET_FAILURE_REQUEST,
		payload,
	};
}
function setDepartmentsAuditList(payload) {
	return {
		type: analyticsConstants?.SET_DEPARTMENTS_AUDIT_LIST,
		payload,
	};
}
function loading(payload) {
	return {
		type: analyticsConstants?.SET_LOADING_REQUEST,
		payload,
	};
}

function isSuccess(payload) {
	return {
		type: analyticsConstants?.SET_SUCCESS,
		payload,
	};
}

function setDepartmentsList(payload) {
	return {
		type: analyticsConstants?.SET_DEPARTMENTS_LIST,
		payload,
	};
}

function setUsersList(payload) {
	return {
		type: analyticsConstants?.SET_USERS_LIST,
		payload,
	};
}

function fetchTransitLossList(payload, singleFetch = false) {
	return async (dispatch) => {
		try {
			dispatch(loading(true));
			const response = await analyticsServices.fetchTransitLossList(payload);
			if (response?.statusCode === 200) {
				if (singleFetch) {
					dispatch(setSingleTransitLoss(response?.data));
				} else {
					dispatch(transitLossList(response?.data));
				}
			}
		}
		catch (error) {
			dispatch(faliureRequest(error));
		}
		finally {
			dispatch(loading(false));
		}
	}
}

function saveTransitLossRecoverdQty(payload) {
	return async (dispatch) => {
		try {
			dispatch(loading(true));
			const response = await analyticsServices.saveTransitLossRecoverdQty(payload);
			if (response?.statusCode === 200) {
				dispatch(isSuccess('Transit Loss Recovered Qty Saved Successfully'));
			}
		}
		catch (error) {
			dispatch(faliureRequest(error));
		}
		finally {
			dispatch(loading(false));
		}
	}
}

function fetchDepartmentsAuditList(filters) {
	return async (dispatch) => {
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'loading.....',
		});
		try {
			const req = {
				data: {
					...(filters?.store?.id && filters?.store?.id !== -999 && { storeId: filters?.store?.id }),
					...(filters?.type && filters?.type !== 'ALL' && { status: filters?.type }),
					...(filters?.dateRange?.from && {
						startDate: moment(filters?.dateRange?.from).format('YYYY-MM-DD 00:00:00'),
					}),
					...(filters?.dateRange?.to && {
						endDate: moment(filters?.dateRange?.to).format('YYYY-MM-DD 23:59:59'),
					}),
				},
			};
			const response = await departmentServices.fetchDepartmentsAuditList(req);
			if (response?.statusCode === 200) {
				const formatted = (response?.data ?? []).map((item) => ({
					...item,
					createdAt: item?.createdAt
						? moment(item.createdAt).format('YYYY-MM-DD hh:mm A')
						: '-',
				}));
				dispatch(setDepartmentsAuditList(formatted));
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Audit list fetched successfully',
					config: { id: notificationId }
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message ?? 'Failed to fetch audits',
					config: { id: notificationId }
				});
			}
			return response;
		} catch (error) {
			console.error(error);
			notificationServices.generateNotification({
				type: 'error',
				message: 'An error occurred while fetching audits',
				config: { id: notificationId }
			});
		} finally {
			notificationServices.closeNotification(notificationId);
		}
	}
}

export default wastageAction;
